import Vue from "vue";
import App from "./App.vue";
import VueRouter from "vue-router";
import "bootstrap/dist/css/bootstrap.css";
import "flag-icon-css/css/flag-icons.min.css";
import router from "./router";
import store from "./store";
import i18n from "./i18n";
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import {
  faInfo,
  faGraduationCap,
  faLocationDot,
  faCheck,
} from "@fortawesome/free-solid-svg-icons";
import { faClock, faCalendar } from "@fortawesome/free-regular-svg-icons";
import {
  faInstagram,
  faFacebookF,
  faLinkedinIn,
} from "@fortawesome/free-brands-svg-icons";
import MasonryWall from "@yeger/vue2-masonry-wall";
import * as validations from "./misc/validations";
// import { updateValidationMessages } from './misc/validations';

library.add(faInfo);
library.add(faGraduationCap);
library.add(faLocationDot);
library.add(faClock);
library.add(faCheck);
library.add(faCalendar);
library.add(faInstagram);
library.add(faFacebookF); // Add the Facebook icon to the library
library.add(faLinkedinIn); // Add the LinkedIn icon to the library

Vue.component("font-awesome-icon", FontAwesomeIcon);

Vue.use(VueRouter);
Vue.use(MasonryWall);
Vue.use(validations);

Vue.config.productionTip = false;
import { mapGetters } from "vuex";
import { mapActions } from "vuex/dist/vuex.common.js";

new Vue({
  render: (h) => h(App),
  router,
  store,
  i18n,
  computed: {
    ...mapGetters(["currentLocale"]),
  },
  methods: {
    ...mapActions(["changeLocale"]),
  },
  watch: {
    "$i18n.locale": {
      immediate: true,
      handler(newLocale) {
        this.changeLocale(newLocale);
        // updateValidationMessages(newLocale);
      },
    },
  },
}).$mount("#app");
